import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

import { BaseProvider } from './base-provider';

@Injectable()
export class ConsumerMoneyOrderHandlerProvider extends BaseProvider{
	url: any;
	order: any; 
	allOrders: any = [];

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
		super();
	}

	getOrders(params){	
		return new Promise( (resolve, reject) => {
		  	this.url = this.globals.dataUrl + 'consumerMoneyOrder' + 
		  									  '/business/' + params.businessId +
											  '/page/' + params.page +
											  '/size/' + params.size;

			this.storage.get('loginData').then((loginData) => {
				this.http.get(
					this.url,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						this.list = data.Data;
						
						resolve(data);
					},
					err => {reject(err)}
				);
			});
		});       	
  	}	  

	getOrdersForAllBusinesses(params){	
	  	this.url = this.globals.dataUrl + 'consumerMoneyOrder' + 
										  '/page/' + params.page +
										  '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );    
    	})  	     
  	}	  	
}



// WEBPACK FOOTER //
// ./src/providers/consumer-money-order-handler.ts